import React, { useEffect } from 'react';
import {
  Container,
  StyledBreadcrumbs,
  MainTitle,
  ReviewSection,
  LeftColumn,
  RightColumn,
  PaymentShippingDetailsWrapper
} from './styles';
import TermsofServiceComponent from './TermsofService/TermsofServiceComponent';
import PlanSummary from './PlanSummary/PlanSummary';
import { useTranslationHelper } from 'src/contexts/dependencyManager/utils';
import { PaymentMethod } from '../PaymentMethod';
import { ShippingAddress } from '../ShippingAddress';
import { SubscriptionStateResponse } from 'src/types/subscription';
import { useShippingAddress } from 'src/hooks/useShippingAddress';
import useShellContext from 'src/hooks/useShellContext';
import useBillingClient from 'src/hooks/useUsageClient';
import { useData } from 'src/contexts/DataContext';
import { PrinterItem } from 'src/utils/Products/productFilter';

interface UpgradeReviewProps {
  onBack?: () => void;
  onConfirm?: () => void;
  subscriptions?: SubscriptionStateResponse[];
  selectedPrinterDetails?: PrinterItem;
  currentPrinterDetails?: PrinterItem[];
}

const UpgradeReview = ({
  onBack,
  onConfirm,
  subscriptions,
  selectedPrinterDetails,
  currentPrinterDetails
}: UpgradeReviewProps): JSX.Element => {
  const getText = useTranslationHelper();
  const { authProvider, stack } = useShellContext();
  const { setUsageData, setCurrentUsageData, setRolloverData } = useData();
  const { fetchAllUsageData } = useBillingClient({
    setUsageData,
    setCurrentUsageData,
    setRolloverData
  });

  const paymentMethodId = subscriptions?.[0]?.paymentMethodId || '';
  const shippingAddressId =
    subscriptions?.[0]?.entities?.[0]?.shippingAddressId || '';

  const { shippingAddress, loading, error } = useShippingAddress({
    authProvider,
    stack,
    shippingAddressId
  });

  useEffect(() => {
    fetchAllUsageData(
      subscriptions?.[0]?.subscriptionId,
      subscriptions?.[0]?.entities?.[0]?.entityId
    );
  }, []);

  return (
    <Container>
      <StyledBreadcrumbs>
        {getText('step2Of2', 'Step 2 of 2')}
      </StyledBreadcrumbs>
      <MainTitle data-testid="upgradeReviewHeader">
        Review your upgrade
      </MainTitle>

      <ReviewSection>
        <LeftColumn>
          <PlanSummary
            selectedPrinterDetails={selectedPrinterDetails}
            currentPrinterDetails={currentPrinterDetails}
          />
          <PaymentShippingDetailsWrapper>
            <PaymentMethod paymentMethodId={paymentMethodId} />
            <ShippingAddress
              shippingAddress={shippingAddress}
              isLoading={loading}
              error={error}
            />
          </PaymentShippingDetailsWrapper>
        </LeftColumn>

        <RightColumn>
          <TermsofServiceComponent
            onBack={onBack}
            onConfirm={onConfirm}
          />
        </RightColumn>
      </ReviewSection>
    </Container>
  );
};

export default UpgradeReview;
